import type { CategoryId } from '@/data';

export interface CategoryQuestion {
  id: string;
  categoryId: CategoryId | string;
  question: string;
  context?: string; // Why we're asking, educational info
  forWho: 'her' | 'him' | 'both'; // Who should answer
  type: 'text' | 'scale' | 'choice';
  choices?: string[]; // For choice type
  placeholder?: string;
}

// Category-specific questions to understand preferences for better curation
export const CATEGORY_QUESTIONS: CategoryQuestion[] = [
  // Oral - BJ focused questions
  {
    id: 'oral-her-technique',
    categoryId: 'oral',
    question: 'How would you describe your oral technique?',
    context: 'Understanding your style helps us suggest videos that match what you enjoy doing.',
    forWho: 'her',
    type: 'text',
    placeholder: 'e.g., I love focusing on the frenulum, using lots of tongue...'
  },
  {
    id: 'oral-her-deepthroat',
    categoryId: 'oral',
    question: 'Do you enjoy taking him deep / can you deepthroat?',
    forWho: 'her',
    type: 'choice',
    choices: ['Yes, I love it', 'Sometimes / working on it', 'Not really my thing', 'Would like to learn']
  },
  {
    id: 'oral-her-gagging',
    categoryId: 'oral',
    question: 'Do you enjoy going a little too far with gagging and using the spit?',
    context: 'Some content features more intense techniques - helps us know if that appeals to you.',
    forWho: 'her',
    type: 'choice',
    choices: ['Love it - the messier the better', 'Sometimes in the moment', 'Prefer more sensual/gentle', 'Curious to try']
  },
  {
    id: 'oral-him-finish',
    categoryId: 'oral',
    question: 'How does he usually finish during oral?',
    forWho: 'her',
    type: 'choice',
    choices: ['In my mouth', 'On my face', 'On my body', 'Usually transitions to sex', 'Varies']
  },
  {
    id: 'oral-frenulum',
    categoryId: 'oral',
    question: 'Are you familiar with frenulum stimulation techniques?',
    context: 'The frenulum is the sensitive V-shaped area on the underside of the head - many videos feature techniques focusing here.',
    forWho: 'her',
    type: 'choice',
    choices: ['Yes, I focus on it a lot', 'Somewhat familiar', 'Would love to learn more', 'What\'s that?']
  },

  // Oral - Him going down on her
  {
    id: 'oral-him-technique',
    categoryId: 'oral',
    question: 'How would you describe how he goes down on you?',
    forWho: 'her',
    type: 'text',
    placeholder: 'e.g., He focuses on the clit, uses lots of tongue, takes his time...'
  },
  {
    id: 'oral-her-wetness-wish',
    categoryId: 'oral',
    question: 'Would you love getting so wet that his face was covered when you came?',
    context: 'Some of our content features very wet/squirting finishes - helps us know your interest level.',
    forWho: 'her',
    type: 'choice',
    choices: ['Already happens!', 'Would love that', 'Sounds fun to try', 'Not really interested']
  },
  {
    id: 'oral-him-enthusiasm',
    categoryId: 'oral',
    question: 'How enthusiastic is he about going down on you?',
    forWho: 'her',
    type: 'choice',
    choices: ['Loves it - could do it for hours', 'Enjoys it regularly', 'Does it but not his favorite', 'Rarely/never']
  },

  // Cum/Volume focused
  {
    id: 'cum-volume-importance',
    categoryId: 'cum',
    question: 'How much does volume matter to you when he finishes?',
    forWho: 'her',
    type: 'choice',
    choices: ['Love big loads - the more the better', 'Enjoy it but not essential', 'Don\'t really notice/care', 'Curious to see more']
  },
  {
    id: 'cum-where-prefer',
    categoryId: 'cum',
    question: 'Where do you most enjoy him finishing?',
    forWho: 'her',
    type: 'choice',
    choices: ['Inside me', 'In my mouth', 'On my face', 'On my body', 'Varies by mood']
  },
  {
    id: 'cum-cleanup',
    categoryId: 'cum',
    question: 'Do you enjoy playing with it after / cleanup situations?',
    forWho: 'her',
    type: 'choice',
    choices: ['Yes, love it', 'Sometimes', 'Not really', 'Haven\'t tried much']
  },

  // Squirting focused
  {
    id: 'squirt-experience',
    categoryId: 'squirt',
    question: 'What\'s your experience with squirting?',
    forWho: 'her',
    type: 'choice',
    choices: ['Happens regularly', 'Occasionally', 'Happened once or twice', 'Never but want to', 'Not interested']
  },
  {
    id: 'squirt-technique',
    categoryId: 'squirt',
    question: 'What usually makes it happen for you (if it does)?',
    forWho: 'her',
    type: 'text',
    placeholder: 'e.g., G-spot stimulation, certain positions, toys...'
  },
  {
    id: 'squirt-his-reaction',
    categoryId: 'squirt',
    question: 'How does he feel about squirting?',
    forWho: 'her',
    type: 'choice',
    choices: ['Loves it - turns him on', 'Enjoys it when it happens', 'Neutral', 'Would like to make it happen', 'Haven\'t discussed']
  },

  // Wetness focused
  {
    id: 'wetness-natural',
    categoryId: 'wet',
    question: 'How naturally wet do you get?',
    forWho: 'her',
    type: 'choice',
    choices: ['Very wet - soaking', 'Plenty wet', 'Average', 'Sometimes need help', 'Varies a lot']
  },
  {
    id: 'wetness-desire',
    categoryId: 'wet',
    question: 'Would you want to be wetter during sex?',
    forWho: 'her',
    type: 'choice',
    choices: ['Yes, always want more', 'Sometimes would be nice', 'Happy as is', 'Already very wet']
  },

  // Positions
  {
    id: 'positions-favorite',
    categoryId: 'positions',
    question: 'What are your favorite positions and why?',
    forWho: 'both',
    type: 'text',
    placeholder: 'Tell us what positions you both enjoy most...'
  },
  {
    id: 'positions-try',
    categoryId: 'positions',
    question: 'Any positions you\'ve seen that you want to try?',
    forWho: 'both',
    type: 'text',
    placeholder: 'Describe or name positions you\'re curious about...'
  },

  // Toys
  {
    id: 'toys-current',
    categoryId: 'toys',
    question: 'What toys do you currently use together?',
    forWho: 'both',
    type: 'text',
    placeholder: 'e.g., vibrators, cock rings, couples toys...'
  },
  {
    id: 'toys-interest',
    categoryId: 'toys',
    question: 'Interested in seeing more toy-focused content?',
    forWho: 'both',
    type: 'choice',
    choices: ['Yes, love toy content', 'Some types interest me', 'Not really into toys', 'Want to explore more']
  },

  // Fantasy/Roleplay
  {
    id: 'fantasy-untried',
    categoryId: 'roleplay',
    question: 'Any fantasies you haven\'t tried yet that you\'d love to explore?',
    forWho: 'both',
    type: 'text',
    placeholder: 'Share what you\'re curious about trying...'
  },

  // General turnons
  {
    id: 'general-turnons',
    categoryId: 'general',
    question: 'What turns you on most in adult content?',
    forWho: 'both',
    type: 'text',
    placeholder: 'Chemistry, passion, specific acts, aesthetics...'
  },
  {
    id: 'general-turnoffs',
    categoryId: 'general',
    question: 'What turns you off or do you want to avoid?',
    forWho: 'both',
    type: 'text',
    placeholder: 'Help us filter out content you won\'t enjoy...'
  }
];

// Get questions for a specific category (only category-specific questions, no general fallback)
export const getQuestionsForCategory = (categoryId: string): CategoryQuestion[] => {
  return CATEGORY_QUESTIONS.filter(q => q.categoryId === categoryId);
};

// Get unanswered questions for a category
export const getUnansweredQuestions = (
  categoryId: string,
  answeredQuestionIds: string[]
): CategoryQuestion[] => {
  return getQuestionsForCategory(categoryId).filter(q => !answeredQuestionIds.includes(q.id));
};
